/** @jsxImportSource @emotion/react */
import React, { useMemo } from 'react';

import badgeStyles from './badge.styles';
import { useIntl } from 'react-intl';

export enum EBadgeType {
    FREE = 'FREE',
    FREE_CONNECTOR = 'FREE_CONNECTOR',
}

type Props = {
    type: EBadgeType;
};

const Badge = (props: Props) => {
    const { type } = props;
    const intl = useIntl();
    const styles = useMemo(() => {
        if (type === EBadgeType.FREE) {
            return badgeStyles.free;
        } else if (type === EBadgeType.FREE_CONNECTOR) {
            return badgeStyles.freeConnector;
        }
    }, [type]);

    return <div css={styles}>{intl.formatMessage({ id: 'payment.free' })}</div>;
};

export default Badge;
